import React from 'react';
import './index.css'
import { Link } from 'react-router-dom';
import PageBanner from '../../layout/PageBanner';

const Multimedia = (props) => (
  <div >
    <PageBanner title="Multimedia" img="banner-multimedia.jpeg">
      <Link to="/">Home</Link>
      <Link to="/multimedia">Multimedia</Link>
    </PageBanner>

    <div>{console.log(props)}</div>

    <section className="teachers">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="teachers-block">
              <div className="row"> {/* Primer fila - Seminarios */}
                <div className="col-md-10 col-sm-6 about-ds-content">
                  <div className="section-header03">
                    <h2>Seminario Internacional<span> de Propiedad Intelectual</span></h2>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="teachers-block">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="teacher-single">
                          <div className="teacher-image">
                            {/* 267 x 260 */}
                            {props.galeriasSemiarios.length > 0 &&
                              <Link to={{ 
                                pathname: props.galeriasSemiarios[0] ? `/galeria/fotos-seminarios/${props.galeriasSemiarios[0].id}` : 'multimedia', 
                                state: { 
                                  title: "Seminario Internacional de Propiedad Intelectual", 
                                  gallery: props.galeriasSemiarios,
                                  number: 0,
                                  onclick: props.onclick
                                }}}>
                                <img src="images/multimedia/seminarios-fotos.jpg" alt="" className="img-responsive fade-in" />
                              </Link>
                            }
                          </div>
                          <div className="teacher-details">
                            <h3>Fotos</h3>
                            <h4>Galería</h4>
                            <p>Todas las fotos de las distintas ediciones del seminario internacional de propiedad intelectual.</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="teacher-single">
                          <div className="teacher-image">
                          {props.galeriasSemiariosVideos.length > 0 &&
                            <Link to={{ 
                              pathname: props.galeriasSemiariosVideos[0] ? `/galeria/videos-seminarios/${props.galeriasSemiariosVideos[0].id}` : 'multimedia', 
                              state: { 
                                title: "Seminario Internacional de Propiedad Intelectual", 
                                gallery: props.galeriasSemiariosVideos,
                                number: 0
                              }}}>
                              <img src="images/multimedia/seminarios-videos.jpg" alt="" className="img-responsive fade-in" />
                            </Link>
                          }
                          </div>
                          <div className="teacher-details">
                            <h3>Videos</h3>
                            <h4>Galería</h4>
                            <p>Videos de todas las mesas de las distintas ediciones del seminario internacional de propiedad intelectual.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> {/* Primer fila - Seminarios */}

            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="teachers">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="teachers-block">
              <div className="row"> {/* Segunda Fila - Encuentros Academicos */}
                <div className="col-md-10 col-sm-6 about-ds-content">
                  <div className="section-header03">
                    <h2>Encuentros<span> Académicos</span></h2>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="teachers-block">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="teacher-single">
                          <div className="teacher-image">
                            {/* 267 x 260 */}
                            {props.galeriasEncuentros.length > 0 &&
                            <Link to={{ 
                              pathname: props.galeriasEncuentros[0] ? `/galeria/fotos-encuentros/${props.galeriasEncuentros[0].id}` : 'multimedia', 
                              state: { 
                                title: "Encuentros Académicos", 
                                gallery: props.galeriasEncuentros,
                                number: 0,
                                onclick: props.onclick
                              }}}>
                              <img src="images/multimedia/encuentros-fotos.jpg" alt="" className="img-responsive fade-in" />
                            </Link>
                            }
                          </div>
                          <div className="teacher-details">
                            <h3>Fotos</h3>
                            <h4>Galería</h4>
                            <p>Registro fotográfico de nuestras charlas abiertas y workshops.</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="teacher-single">
                          <div className="teacher-image">
                          {props.galeriasEncuentrosVideos.length > 0 &&
                            <Link to={{ 
                              pathname: props.galeriasEncuentrosVideos[0] ? `/galeria/videos-encuentros/${props.galeriasEncuentrosVideos[0].id}` : 'multimedia', 
                              state: { 
                                title: "Encuentros Académicos", 
                                gallery: props.galeriasEncuentrosVideos,
                                number: 0
                              }}}>
                              <img src="images/multimedia/encuentros-videos.jpg" alt="" className="img-responsive fade-in" />
                            </Link>
                            }
                          </div>
                          <div className="teacher-details">
                            <h3>Videos</h3>
                            <h4>Galería</h4>
                            <p>Registro fílmico de nuestras charlas abiertas y workshops.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> {/* Segunda Fila - Encuentros Academicos */}

            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="teachers">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="teachers-block">
              <div className="row"> {/* Tercera fila - Entrevistas */}
                <div className="col-md-10 col-sm-6 about-ds-content">
                  <div className="section-header03">
                    <h2>Entrevistas<span></span></h2>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="teachers-block">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="teacher-single">
                          <div className="teacher-image">
                          {props.galeriasEntrevistas.length > 0 &&
                            <Link to={{ 
                              pathname: props.galeriasEntrevistas[0] ? `/galeria/entrevistas/${props.galeriasEntrevistas[0].id}` : 'multimedia', 
                              state: { 
                                title: "Entrevistas", 
                                gallery: props.galeriasEntrevistas,
                                number: 0
                              }}}>
                              <img src="images/multimedia/entrevistas.jpg" alt="" className="img-responsive fade-in" />
                            </Link>
                            }
                          </div>
                          <div className="teacher-details">
                            <h3>Videos</h3>
                            <h4>Galería</h4>
                            <p>Algunas entrevistas realizadas por y a nuestro equipo docente.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> {/* Tercera fila - Entrevistas */}

            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="teachers">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="teachers-block">
              <div className="row"> {/* Cuarta Fila - Maestrías */}
                <div className="col-md-10 col-sm-6 about-ds-content">
                  <div className="section-header03">
                    <h2><span>Defensa de tesis</span></h2>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="teachers-block">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="teacher-single">
                          <div className="teacher-image">
                            {/* 267 x 260 */}
                            {props.galeriasMaestrias.length > 0 &&
                            <Link to={{ 
                              pathname: props.galeriasMaestrias[0] ? `/galeria/tesis/${props.galeriasMaestrias[0].id}` : 'multimedia', 
                              state: { 
                                title: "Maestría en Propiedad Intelectual", 
                                gallery: props.galeriasMaestrias,
                                number: 0
                              }}}>
                              <img src="images/multimedia/defensa-tesis.jpg" alt="" className="img-responsive fade-in" />
                            </Link>
                            }
                          </div>
                          <div className="teacher-details">
                            <h3>Fotos</h3>
                            <h4>Galería</h4>
                            <p>Fotos de los recién graduados en sus defensas de tesis junto con el jurado.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> {/* Cuarta Fila - Maestrías */}

            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="teachers"></section>

  </div>
);

export default Multimedia;
